import { render } from "./PanelAccordion.vue?vue&type=template&id=587d292b"
import script from "./PanelAccordion.vue?vue&type=script&lang=ts"
export * from "./PanelAccordion.vue?vue&type=script&lang=ts"

import "./PanelAccordion.vue?vue&type=style&index=0&id=587d292b&lang=scss"
script.render = render

export default script